import { NAME as APP_NAME, ROUTES as APP_ROUTES } from 'constants';

export const NAME = `${APP_NAME}/SHIPPERS`;

export const REDUCER_NAME = 'shippers';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/profiles/query?role=SHIPPER`;
